import React from 'react';
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBBtn, MDBSimpleChart, MDBCard, MDBCardBody, MDBIcon, MDBRow, MDBCol, MDBCardText } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import DashboardCard from './ComponentFragments/DashboardCard';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';
import Formatter from '../Utilities/Formatter';
import ProgressBar from './ComponentFragments/Progress-Bar';
import { string } from 'prop-types';

export default class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            managerName: '',
            qualifiedPromoteOuts: 0,
            teamSales: 0,
            totalTeamSales: 0,
            promoteOuts: 0,
            teamPOCount: 0,
            teamRecruits: 0,
            teamQualRecruits: 0,
            personalSales: 0,
            unitSales: 0,
            promoteOutSales: 0,
            totalUnitSales: 0,
            unitSize: 0,
            promoteOuts: 0,
            newRecruits: 0,
            qualifiedRecruits: 0,

            prevNewRecruits: 0,
            prevPersonalSales: 0,
            prevPromoteOuts: 0,
            prevPromoteOutSales: 0,
            prevQualifiedPromoteOuts: 0,
            prevQualifiedRecruits: 0,
            prevTeamPOCount: 0,
            prevTeamQualRecruits: 0,
            prevTeamRecruits: 0,
            prevTeamSales: 0,
            prevTotalTeamSales: 0,
            prevTotalUnitSales: 0,
            prevUnitSales: 0,
            prevUnitSize: 0,

            currentSegmentSales: 0,
            prevSegmentSales: 0,
            currentSegmentRecruits: 0,
            prevSegmentRecruits: 0,
            currentSegmentQualified: 0,
            prevSegmentQualified: 0,

            teamActiveRecruits: 0,
            prevTeamActiveRecruits: 0,

            promoteInData: [],
            PIManagerModalOpen: false,
            PIManagerData: [],
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            unitGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            }
        }
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.getGraphData(this.TMAUser);
        this.formatter = new Formatter();
        this.getLanding = this.getLanding.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showPromoteInManagers = this.showPromoteInManagers.bind(this);
        //Version tester
        //let appSettings = require('../appsettings.json');
        //alert(appSettings.AppVersion);
    }

    closeModal() {
        this.setState({ PIManagerModalOpen: false });
    }

    showPromoteInManagers(lvl) {
        let managers = this.state.promoteInData.managerList
        let piData = [];
        managers.forEach((man) => {
            man.promoteInLvlList.forEach((manLvl) => {
                if (manLvl.lvlIdInternal == lvl.lvlIdInternal && manLvl.salesOnLvl > 0) {
                    piData.push({ salesOnLvl: manLvl.salesOnLvl, firstNames: man.firstNames, surname: man.surname, telephoneCell: man.telephoneCell, unitName: man.unitName})
                }
            })
        })
        this.setState({ PIManagerModalOpen: true, PIManagerData: piData});
    }

    async getGraphData(TMAUser) {
        let dataLayer = new DataLayer();
        if (TMAUser.data.statusCode1 == 'T') {
            await dataLayer.Post('/common/GetGraphData', 1).then((response) => {
                let teamGraphData = {
                    labels: [],
                    currYTDSales: [],
                    prevYTDSales: []
                }

                response.data.forEach((entry) => {
                    teamGraphData.labels.push(entry.month);
                    teamGraphData.currYTDSales.push(entry.currYr);
                    teamGraphData.prevYTDSales.push(entry.prevYr);
                })

                this.setState({
                    teamGraphData: teamGraphData
                })
            })
        }

        if (TMAUser.data.statusCode1 == 'M' || TMAUser.data.statusCode1 == 'T') {
            await dataLayer.Post('/common/GetGraphData', 2).then((response) => {
                let unitGraphData = {
                    labels: [],
                    currYTDSales: [],
                    prevYTDSales: []
                }

                response.data.forEach((entry) => {
                    unitGraphData.labels.push(entry.month);
                    unitGraphData.currYTDSales.push(entry.currYr);
                    unitGraphData.prevYTDSales.push(entry.prevYr);
                })

                this.setState({
                    unitGraphData: unitGraphData
                })
            })
        }

        if (TMAUser.data.statusCode1 == 'D') {
            await dataLayer.Post('/common/GetGraphData', 3).then((response) => {
                let unitGraphData = {
                    labels: [],
                    currYTDSales: [],
                    prevYTDSales: []
                }

                response.data.forEach((entry) => {
                    unitGraphData.labels.push(entry.month);
                    unitGraphData.currYTDSales.push(entry.currYr);
                    unitGraphData.prevYTDSales.push(entry.prevYr);
                })

                this.setState({
                    unitGraphData: unitGraphData
                })
            })
        }
    }

    async componentWillMount() {
        let dataLayer = new DataLayer();
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        if (TMAUser.data.statusCode1 == 'D') {

            await dataLayer.Get('/demonstrator/getdemonstratorstats').then((response) => {
                this.setState({
                    currentSegmentSales: response.data.currentSegmentSales,
                    prevSegmentSales: response.data.prevSegmentSales,
                    currentSegmentRecruits: response.data.currentSegmentRecruits,
                    prevSegmentRecruits: response.data.prevSegmentRecruits,
                    currentSegmentQualified: response.data.currentSegmentQualified,
                    prevSegmentQualified: response.data.prevSegmentQualified
                })
                this.props.loaderOff();
            })
        } else if (TMAUser.data.statusCode1 == 'M') {
            let result = await dataLayer.Get('/manager/getPromoteIns', 200);
            let response = await dataLayer.Get('/manager/getunitstats')
            this.setState({
                promoteInData: result.data,
                managerName: response.managerName,
                qualifiedPromoteOuts: response.qualifiedPromoteOuts,
                teamSales: response.teamSales,
                totalTeamSales: response.totalTeamSales,
                teamPOCount: response.teamPOCount,
                teamRecruits: response.teamRecruits,
                teamQualRecruits: response.teamQualRecruits,
                personalSales: response.personalSales,
                unitSales: response.unitSales,
                promoteOutSales: response.promoteOutSales,
                totalUnitSales: response.totalUnitSales,
                unitSize: response.unitSize,
                promoteOuts: response.promoteOuts,
                newRecruits: response.newRecruits,
                qualifiedRecruits: response.qualifiedRecsInSeg,

                prevNewRecruits: response.prevNewRecruits,
                prevPersonalSales: response.prevPersonalSales,
                prevPromoteOuts: response.prevPromoteOuts,
                prevPromoteOutSales: response.prevPromoteOutSales,
                prevQualifiedPromoteOuts: response.prevQualifiedPromoteOuts,
                prevQualifiedRecruits: response.prevQualifiedRecsInSeg,
                prevTeamPOCount: response.prevTeamPOCount,
                prevTeamQualRecruits: response.prevTeamQualRecruits,
                prevTeamRecruits: response.prevTeamRecruits,
                prevTeamSales: response.prevTeamSales,
                prevTotalTeamSales: response.prevTotalTeamSales,
                prevTotalUnitSales: response.prevTotalUnitSales,
                prevUnitSales: response.prevUnitSales,
                prevUnitSize: response.prevUnitSize
            })
            this.props.loaderOff();

        } else {
            //let result = await dataLayer.Get('/teamleader/getPromoteIns', 200);
            let response = await dataLayer.Get('/teamleader/getteamstats')
            let ffs = "";
            this.setState({
                promoteInData: response.promoteInLevels,
                managerName: response.managerName,
                qualifiedPromoteOuts: response.qualifiedPromoteOuts,
                teamSales: response.teamSales,
                totalTeamSales: response.totalTeamSales,
                teamPOCount: response.teamPOCount,
                teamRecruits: response.teamRecruits,
                teamQualRecruits: response.teamQualRecruits,
                personalSales: response.personalSales,
                unitSales: response.unitSales,
                promoteOutSales: response.promoteOutSales,
                totalUnitSales: response.totalUnitSales,
                unitSize: response.unitSize,
                promoteOuts: response.promoteOuts,
                newRecruits: response.newRecruits,
                qualifiedRecruits: response.qualifiedRecruits,

                prevNewRecruits: response.prevNewRecruits,
                prevPersonalSales: response.prevPersonalSales,
                prevPromoteOuts: response.prevPromoteOuts,
                prevPromoteOutSales: response.prevPromoteOutSales,
                prevQualifiedPromoteOuts: response.prevQualifiedPromoteOuts,
                prevQualifiedRecruits: response.prevQualifiedRecruits,
                prevTeamPOCount: response.prevTeamPOCount,
                prevTeamQualRecruits: response.prevTeamQualRecruits,
                prevTeamRecruits: response.prevTeamRecruits,
                prevTeamSales: response.prevTeamSales,
                prevTotalTeamSales: response.prevTotalTeamSales,
                prevTotalUnitSales: response.prevTotalUnitSales,
                prevUnitSales: response.prevUnitSales,
                prevUnitSize: response.prevUnitSize,
                teamActiveRecruits: response.activeTeamRecruits,
                prevTeamActiveRecruits: response.prevActiveTeamRecruits
            })


            this.props.loaderOff();

        }

    }

    getLanding(TMAUser) {
        if (TMAUser.data.statusCode1 == 'D') {
            return (
                <div >
                    <h3>Demonstrator Stats</h3>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="chart-line"
                                iconColor="#ffdb00"
                                cardName="Sales"
                                value1Description="Personal"
                                currentValue1={this.formatter.formatCurrency(this.state.currentSegmentSales)}
                                value2Description=""
                                currentValue2=""

                                previousValue1={this.formatter.formatCurrency(this.state.prevSegmentSales)}
                                previousValue2=""



                            />
                        </MDBCol>
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="user-plus"
                                iconColor="#e30385"
                                cardName="Recruits"
                                value1Description="New"
                                currentValue1={this.state.currentSegmentRecruits}
                                value2Description="Qualified"
                                currentValue2={this.state.currentSegmentQualified}

                                previousValue1={this.state.prevSegmentRecruits}
                                previousValue2={this.state.prevSegmentQualified}



                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="12" sm="12" >
                            <DashboardLineGraph chartName="Personal Sales Performance" graphData={this.state.unitGraphData} />
                        </MDBCol>
                    </MDBRow>
                </div>
            )
        } else if (TMAUser.data.statusCode1 == 'T') {
            return (
                <div >
                    <h3>Team Stats</h3>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol xl="4" lg="6" md="6" sm="12" className="mb-r" >

                            <DashboardCard iconName="chart-line"
                                iconColor="#ffdb00"
                                cardName="Team Sales"
                                value1Description="Total Team Sales"
                                currentValue1={this.formatter.formatCurrency(this.state.totalTeamSales)}
                                value2Description="Team Sales"
                                currentValue2={this.formatter.formatCurrency(this.state.teamSales)}

                                previousValue1={this.formatter.formatCurrency(this.state.prevTotalTeamSales)}
                                previousValue2={this.formatter.formatCurrency(this.state.prevTeamSales)}
                            />

                        </MDBCol>


                        <MDBCol xl="4" lg="6" md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="user-plus"
                                iconColor="#e30385"
                                cardName="Team Recruits"
                                cardType="Team_Recruits"
                                value1Description="Total"
                                value2Description="Qualified"
                                value3Description="Active"

                                currentValue1={this.state.teamRecruits}
                                currentValue2={this.state.teamQualRecruits}
                                currentValue3={this.state.teamActiveRecruits}

                                previousValue1={this.state.prevTeamRecruits}
                                previousValue2={this.state.prevTeamQualRecruits}
                                previousValue3={this.state.prevTeamActiveRecruits}

                            />
                        </MDBCol>
                        <MDBCol xl="4" lg="6" md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="level-up-alt"
                                iconColor="#671f75"
                                cardName="Team P/O's"
                                value1Description="Total"
                                currentValue1={this.state.teamPOCount}
                                value2Description="Qualified"
                                currentValue2={this.state.qualifiedPromoteOuts}

                                previousValue1={this.state.prevTeamPOCount}
                                previousValue2={this.state.prevQualifiedPromoteOuts}



                            />
                        </MDBCol>

                    </MDBRow>
                    <h3>Personal Unit Stats</h3>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="chart-line"
                                iconColor="#ffdb00"
                                cardName="Sales"
                                value1Description="Personal"
                                currentValue1={this.formatter.formatCurrency(this.state.personalSales)}
                                value2Description="Unit"
                                currentValue2={this.formatter.formatCurrency(this.state.unitSales)}

                                previousValue1={this.formatter.formatCurrency(this.state.prevPersonalSales)}
                                previousValue2={this.formatter.formatCurrency(this.state.prevUnitSales)}



                            />
                        </MDBCol>
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="user-plus"
                                iconColor="#e30385"
                                cardName="Recruits"
                                value1Description="New"
                                currentValue1={this.state.newRecruits}
                                value2Description="Qualified"
                                currentValue2={this.state.qualifiedRecruits}

                                previousValue1={this.state.prevNewRecruits}
                                previousValue2={this.state.prevQualifiedRecruits}



                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="level-up-alt"
                                iconColor="#671f75"
                                cardName="Unit P/O's"
                                value1Description="Total"
                                currentValue1={this.state.promoteOuts}
                                value2Description="P/O Sales"
                                currentValue2={this.state.promoteOutSales}

                                previousValue1={this.state.prevPromoteOuts}
                                previousValue2={this.state.prevPromoteOutSales}



                            />
                        </MDBCol>
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="chart-pie"
                                iconColor="#09b3ae"
                                cardName="General"
                                value1Description="Unit Size"
                                currentValue1={this.state.unitSize}
                                value2Description="Total Sales"
                                currentValue2={this.formatter.formatCurrency(this.state.totalUnitSales)}

                                previousValue1={this.state.prevUnitSize}
                                previousValue2={this.formatter.formatCurrency(this.state.prevTotalUnitSales)}



                            />
                        </MDBCol>
                    </MDBRow>
                    <h3>Promote-in Details</h3>
                    <h5>Applies to 2nd Gen Promote-In managers that have promote-in's of their own.</h5>
                    <span style={{fontSize: "13px"}}>(Sales from 2nd Gen Promote-In managers below will start counting toward team sales once they have qualified at the level indicated. Only Managers promoted in week 202115 and later are eligible)</span>
                    <MDBRow>
                        <MDBCol md="12" sm="12" >
                            <MDBCard style={{ marginBottom: "7px", marginTop: "7px" }}>
                                <MDBCardBody>
                                    {this.state.promoteInData.map((lvl) => {
                                        return (
                                            <MDBCardText>
                                                <MDBRow className="mx-2" between>

                                                    <MDBCol md="4" sm="6" >
                                                        <strong>Unit:</strong> {lvl.unitName}<br />
                                                        <strong>Name:</strong> {lvl.firstNames}<br />
                                                        <strong>Surname:</strong> {lvl.surname}<br />
                                                        <strong>Cell No:</strong> {lvl.smsQueryCell}<br />
                                                        <strong>Unit Start: </strong>{lvl.startWeekId}<br />
                                                        <strong>Unit Age: </strong>{ lvl.unitAge}<br />
                                                        <strong>Sales:</strong> {this.formatter.formatCurrency(lvl.salesOnLvl)}
                                                    </MDBCol>
                                                    <MDBCol md="4" sm="6" >
                                                        <strong>Promote-in Level:</strong> { lvl.levelName}<br />
                                                        <strong>Qualification Level:</strong> {this.formatter.formatCurrency(lvl.level)}<br />
                                                        <strong>Starts From Week:</strong> {lvl.startsAt}<br />
                                                        <strong>Ends at Week:</strong> {lvl.endsAt == -1 ? "Onwards" : lvl.endsAt}<br />
                                                        {lvl.salesOnLvl >= lvl.level ? "Congrats Earnings Unlocked For This Unit" : this.formatter.formatCurrency((lvl.level - lvl.salesOnLvl)) + " to go to unlock earnings."}
                                                    </MDBCol>
                                                    <MDBCol md="4" sm="6" >
                                                        <MDBSimpleChart
                                                            width="100"
                                                            height="100"
                                                            strokeWidth="4"
                                                            percent={((lvl.salesOnLvl / lvl.level) * 100).toFixed(0)}
                                                            strokeColor="#de3162"
                                                            labelFontWeight="300"
                                                            labelColor="#000"
                                                        />
                                                    </MDBCol>




                                                </MDBRow>
                                                <hr className="hr_grey" />
                                            </MDBCardText>
                                        )
                                    })}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>

                    {/*    <h3>Ecomm Stats</h3>*/}
                    {/*<MDBRow className="mt-5 mb-5">*/}
                    {/*    <MDBCol className="mb-r" >*/}
                    {/*        <DashboardEcommCard iconName="money-bill-alt"*/}
                    {/*            iconColor="#1bbcd1"*/}
                    {/*            cardName="Ecomm Sales"*/}
                    {/*            value1Description="Team Ecomm Sales"*/}
                    {/*            currentValue1="1200.00"*/}
                    {/*            value2Description="Personal Ecomm Sales"*/}
                    {/*            currentValue2="500.00"*/}

                    {/*            previousValue1="1300.00"*/}
                    {/*            previousValue2="450.00"*/}



                    {/*        />*/}
                    {/*    </MDBCol>*/}
                    {/*    </MDBRow>*/}
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" >
                            <DashboardLineGraph chartName="Team Sales Performance" graphData={this.state.teamGraphData} />
                        </MDBCol>

                        <MDBCol md="6" sm="12" >
                            <DashboardLineGraph chartName="Personal Unit Sales Performance" graphData={this.state.unitGraphData} />
                        </MDBCol>
                    </MDBRow>
                </div >

            )
        } else {
            return (

                <div>
                    <h3>Personal Unit Stats</h3>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="chart-line"
                                iconColor="#ffdb00"
                                cardName="Sales"
                                value1Description="Personal"
                                currentValue1={this.formatter.formatCurrency(this.state.personalSales)}
                                value2Description="Unit"
                                currentValue2={this.formatter.formatCurrency(this.state.unitSales)}

                                previousValue1={this.formatter.formatCurrency(this.state.prevPersonalSales)}
                                previousValue2={this.formatter.formatCurrency(this.state.prevUnitSales)}



                            />
                        </MDBCol>
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="user-plus"
                                iconColor="#e30385"
                                cardName="Recruits"
                                value1Description="New"
                                currentValue1={this.state.newRecruits}
                                value2Description="Qualified"
                                currentValue2={this.state.qualifiedRecruits}

                                previousValue1={this.state.prevNewRecruits}
                                previousValue2={this.state.prevQualifiedRecruits}



                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="level-up-alt"
                                iconColor="#671f75"
                                cardName="Unit P/O's"
                                value1Description="Total"
                                currentValue1={this.state.promoteOuts}
                                value2Description="P/O Sales"
                                currentValue2={this.formatter.formatCurrency(this.state.promoteOutSales)}

                                previousValue1={this.state.prevPromoteOuts}
                                previousValue2={this.formatter.formatCurrency(this.state.prevPromoteOutSales)}



                            />
                        </MDBCol>
                        <MDBCol md="6" sm="12" className="mb-r" >
                            <DashboardCard iconName="chart-pie"
                                iconColor="#09b3ae"
                                cardName="General"
                                value1Description="Unit Size"
                                currentValue1={this.state.unitSize}
                                value2Description="Total Sales"
                                currentValue2={this.formatter.formatCurrency(this.state.totalUnitSales)}

                                previousValue1={this.state.prevUnitSize}
                                previousValue2={this.formatter.formatCurrency(this.state.prevTotalUnitSales)}



                            />
                        </MDBCol>
                    </MDBRow>
                    <h3>Promote-in Details</h3>

                    <MDBRow>
                        {this.state.promoteInData.promoteInLvlList !== undefined ?
                            this.state.promoteInData.promoteInLvlList.length == 0 ? <div><MDBCol md="12" sm="12" className="mb-r" >No Promote-in Data</MDBCol></div> :
                            this.state.promoteInData.promoteInLvlList.map((lvl) => {
                                if (lvl.level > 0) {
                                    return (

                                        <MDBCol md="6" sm="12" className="mb-r" >
                                            <MDBCard style={{ marginBottom: "7px" }}>
                                                <MDBCardBody>
                                                    <div className="data" class="text-center">
                                                        <strong>{lvl.levelName}</strong><br />

                                                        <span style={{ fontSize: "13px" }}>(Achieve Sales of {this.formatter.formatCurrency(lvl.level)} and Earn {this.state.promoteInData.earningPercentage}% of promote-in sales on this level)</span><br />
                                                        <span style={{ fontSize: "15px" }}>Promote-in sales on this level count from weeks {lvl.startsAt} {lvl.endsAt == -1 ? "onwards" : "to " + lvl.endsAt}</span>
                                                    </div>
                                                    <br /><br />
                                                    <MDBRow>
                                                        <MDBCol md="6" sm="6">
                                                            <span style={{ fontSize: "13px" }}>Promote-in Sales This Level: {this.formatter.formatCurrency(lvl.salesOnLvl)}</span><br />
                                                            <span style={{ fontSize: "13px" }}>{this.state.promoteInData.unitSalesIncPromoteoutSales > lvl.level ? "Your" : "Potential"} Earnings This Level: {this.formatter.formatCurrency((lvl.salesOnLvl * this.state.promoteInData.earningPercentage) / 100)}</span><br />
                                                        </MDBCol>
                                                        <MDBCol md="6" sm="6" className="text-right">
                                                            <MDBBtn tag="a" color="cyan" floating onClick={() => this.showPromoteInManagers(lvl)}>
                                                                <MDBIcon icon="info" />
                                                            </MDBBtn>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <hr />
                                                    <div class="text-center">

                                                        <MDBRow>
                                                            <MDBCol md="12" sm="12">
                                                                <MDBSimpleChart
                                                                    width="100"
                                                                    height="100"
                                                                    strokeWidth="4"
                                                                    percent={((this.state.promoteInData.unitSalesIncPromoteoutSales / lvl.level) * 100).toFixed(0)}
                                                                    strokeColor="#de3162"
                                                                    labelFontWeight="300"
                                                                    labelColor="#000"
                                                                />
                                                            </MDBCol>
                                                        </MDBRow>
                                                        <MDBRow>
                                                            <MDBCol md="12" sm="12">
                                                                {this.state.promoteInData.unitSalesIncPromoteoutSales > lvl.level ? "Congrats, Earnings Unlocked" : this.formatter.formatCurrency((lvl.level - this.state.promoteInData.unitSalesIncPromoteoutSales)) + " to go to unlock these earnings"}
                                                            </MDBCol>
                                                        </MDBRow>
                                                        <MDBRow>
                                                            <MDBCol md="12" sm="12">
                                                                <span style={{ fontSize: "13px" }}>Target: {this.formatter.formatCurrency(lvl.level)}</span><br />
                                                                <span style={{ fontSize: "13px" }}>Progress: {this.formatter.formatCurrency(this.state.promoteInData.unitSalesIncPromoteoutSales)}</span><br />
                                                                <span style={{ fontSize: "13px" }}>Shortfall: {this.state.promoteInData.unitSalesIncPromoteoutSales > lvl.level ? 0 : this.formatter.formatCurrency((lvl.level - this.state.promoteInData.unitSalesIncPromoteoutSales))}</span><br />
                                                                <span style={{ fontSize: "13px" }}>Over: {this.state.promoteInData.unitSalesIncPromoteoutSales > lvl.level ? this.formatter.formatCurrency((this.state.promoteInData.unitSalesIncPromoteoutSales - lvl.level)) : 0}</span>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </div>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBCol>
                                    )
                                }

                            })
                            : (<div></div>)}








                    </MDBRow>
                    <MDBRow className="mt-5 mb-5">
                        <MDBCol md="12" sm="12" >
                            <DashboardLineGraph chartName="Personal Unit Sales Performance" graphData={this.state.unitGraphData} />
                        </MDBCol>
                    </MDBRow>


                </div>
            )
        }
    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));

        return (
            <div>
                {this.getLanding(TMAUser)}
                <MDBModal isOpen={this.state.PIManagerModalOpen} toggle={this.state.PIManagerModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon icon="hand-holding-usd" /></span>&nbsp;Manager/s Contributing at this level</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.PIManagerData.map((man) => {
                            return (<div>
                                Name: {man.firstNames}&nbsp;{man.surname}<br />
                                Unit Name: {man.unitName}<br />
                                Tel: {man.telephoneCell}<br />
                                Contributing Sales: {this.formatter.formatCurrency(man.salesOnLvl)}
                            </div>)
                        }
                        )}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.closeModal}>OK</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>
        );
    }
}